// SF-174: generalizes useWarRoomState.ts's/WarRoomTargetCard.tsx's private `isSohdStale` helpers
// into one canonical, importable-from-anywhere home — consolidated rather than left as a third
// one-off copy for the new DefenseLeftAtHomeCard/EstimatedGainPanel components to duplicate.
// 1 tick = 1 hour in game (docs/TIME.md).
const TICK_INTERVAL_MS = 60 * 60 * 1000;

export function isIntelStale(capturedAt: string): boolean {
  const ageMs = Date.now() - new Date(capturedAt).getTime();
  return ageMs >= TICK_INTERVAL_MS;
}
